import CONFIG from "config/config";
export * from "./compras.constants";
export * from "./client-data.constants";
export * from "./dev-data.constants";
export * from "./bulk-edit.constants";
export * from "./search-params.constants";

const BACKEND_PRODUCTION = {
  RENDER_COM_APP: "https://perfumeria-mundial-inc.onrender.com/api",
  RAILWAY_APP: "https://perfumeriamundiale-shop-production.up.railway.app/api",
};

export const BACKEND_ROOT = CONFIG.BACKEND_URL;

export const HEADERS_NAME = "auth";
export const LSTORAGE_KEY_USER = "user";
export const LSTORAGE_KEY_ONGOING_PURCHASE = "ongoingPurchase";
export const LSTORAGE_KEY_CARRITO = "carrito";
export const LSTORAGE_KEY_THEME = "theme";

export const ADDRESS_STEP_PROVINCIA = "Seleccioná provincia";
export const FAILED_REFRESH = "sent";

export const CONSUMIDOR_CABA =
  "https://www.buenosaires.gob.ar/defensaconsumidor";

//hay un type aparte, tecnicamente esta duplicado, pero como son literals no creo q joda, a futuro si los puedo linkear golazo
export const STATUS_PAGO = {
  PENDIENTE: "pendiente",
  APROBADO: "aprobado",
  CANCELADO: "cancelado",
} as const;

export const HASH_LINKS = {
  PROD: "prods",
  TOP: "top",
} as const;

class URL_BACK_ENDPOINTS {
  #PREGUNTAS = "/preguntas" as const;
  PRODUCTOS = "/productos" as const;
  PRODUCTOS_EXCEL = `${this.PRODUCTOS}/nopagination/excel`;
  PRODUCTOS_DESTACADOS = `${this.PRODUCTOS}/nopagination/destacados`;
  PRODUCTOS_GROUP_EDIT = `${this.PRODUCTOS}/bulk` as const;
  dynamicSingleProdPREGUNTAS(pregId: IPregunta["_id"]) {
    return `${this.#PREGUNTAS}/${pregId}` as const;
  }
  dynamicAdminGetAllPregs(optionsObj) {
    let query = "";
    Object.entries(optionsObj).forEach(
      ([key, value]) => (query += `${key}=${value}&`)
    );

    return `${this.#PREGUNTAS}/?${query}`;
  }
  AUTH = "/users/auth";
  COMPRAS = "/checkout/pagos" as const;
  PROFILE = "/profile";
  PROFILE_EDIT_PWD = `${this.PROFILE}/pwd`;
  MARCAS = "/marcas";
  VISITS = "/visits";
  LOGIN = `${this.AUTH}/login`;
  REGISTER = `${this.AUTH}/register`;
  REFRESH = `${this.AUTH}/refresh`;
  LOGOUT = `${this.AUTH}/logout`;
  CONTACT = `${this.AUTH}/contact`;
  CHECKCART = `${this.PRODUCTOS}/checkcart` as const;
}
export const BACKEND_ENDPOINTS = new URL_BACK_ENDPOINTS();
const productos = "/productos";

export const GENERIC_ID_PARAMS = "_id";
const idParam = `:${GENERIC_ID_PARAMS}`;

class URL_FRONT_ENDPOINTS {
  HOME = "/" as const;
  AUTH = "/user/auth" as const;
  CARRITO = "/compras/carrito" as const;
  CHECKOUT = "/compras/checkout" as const;
  SUCCESS = `${this.CHECKOUT}/success` as const;
  CONFIRMED = `${this.CHECKOUT}/confirmed/${idParam}` as const;
  dynamicConfirmed(id: ICompra["_id"]) {
    return this.CONFIRMED.replace(idParam, id);
  }
  SINGLEPRODUCT = `${productos}/${idParam}` as const;
  dynamicSingleProduct(id: IProducto["_id"]) {
    return `${productos}/${id}` as const;
  }
  USER_PROFILE = "/profile" as const;
  CONTACT = "/contacto";
  LOGIN = `${this.AUTH}/login`;
  REGISTER = `${this.AUTH}/register`;
  FORGOT_PASSWORD = `${this.AUTH}/forgotpassword`;
  CHANGE_PASSWORD = `${this.FORGOT_PASSWORD}/:secretToken/changePassword`;
  //VER SINGLE COMPRA y singleproducto y adminprofile para .SINGLEPRODUCT
  /* ----------------ADMIN----------------- */
  ADMIN = "/admin" as const;
  ADMIN_CREATE_PROD = `${this.ADMIN}/create` as const;
  ADMIN_CUSTOMERS = `${this.ADMIN}/customers` as const;
  ADMIN_MARCAS = `${this.ADMIN}/marcas` as const;
  ADMIN_SALES = `${this.ADMIN}/sales` as const;
  ADMIN_PREGUNTAS = `${this.ADMIN}/preguntas` as const;
  ADMIN_VISITS = `${this.ADMIN}/visits` as const;
}
export const FRONTEND_ENDPOINTS = new URL_FRONT_ENDPOINTS();
